import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-950 text-white pt-16 pb-8 border-t border-navy-800" data-id="element-127">
      <div className="container mx-auto px-4 md:px-6" data-id="element-128">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-129">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-130">
            <img src="https://i.imgur.com/2fq6zum.png" alt="Innova Pools Logo" className="h-16 mb-6 brightness-0 invert opacity-90" data-id="element-131" />
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-132">
              Expertos en remodelación y mantenimiento de piscinas residenciales
              en Central Florida. Garantizamos agua cristalina y resultados
              excepcionales.
            </p>
          </div>

          {/* Links */}
          <div data-id="element-133">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-134">
              Enlaces Rápidos
            </h4>
            <ul className="space-y-3" data-id="element-135">
              <li data-id="element-136">
                <a href="#inicio" className="text-gray-400 hover:text-pool-400 transition-colors" data-id="element-137">
                  Inicio
                </a>
              </li>
              <li data-id="element-138">
                <a href="#servicios" className="text-gray-400 hover:text-pool-400 transition-colors" data-id="element-139">
                  Servicios
                </a>
              </li>
              <li data-id="element-140">
                <a href="#remodelaciones" className="text-gray-400 hover:text-pool-400 transition-colors" data-id="element-141">
                  Sobre Nosotros
                </a>
              </li>
              <li data-id="element-142">
                <a href="#testimonios" className="text-gray-400 hover:text-pool-400 transition-colors" data-id="element-143">
                  Testimonios
                </a>
              </li>
              <li data-id="element-144">
                <a href="#contacto" className="text-gray-400 hover:text-pool-400 transition-colors" data-id="element-145">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-2" data-id="element-146">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-147">
              Información de Contacto
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-148">
              <div className="flex items-start gap-3" data-id="element-149">
                <Phone className="text-pool-500 mt-1 flex-shrink-0" size={20} data-id="element-150" />
                <div data-id="element-151">
                  <p className="text-sm text-gray-400 mb-1" data-id="element-152">
                    Teléfono / WhatsApp
                  </p>
                  <a href="https://wa.me/16893266071" className="text-white hover:text-pool-400 transition-colors font-medium" data-id="element-153">
                    +1 (689) 326-6071
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-154">
                <Mail className="text-pool-500 mt-1 flex-shrink-0" size={20} data-id="element-155" />
                <div data-id="element-156">
                  <p className="text-sm text-gray-400 mb-1" data-id="element-157">Email</p>
                  <a href="mailto:innovapoolsystems@gmail.com" className="text-white hover:text-pool-400 transition-colors font-medium" data-id="element-158">
                    innovapoolsystems@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3 sm:col-span-2" data-id="element-159">
                <MapPin className="text-pool-500 mt-1 flex-shrink-0" size={20} data-id="element-160" />
                <div data-id="element-161">
                  <p className="text-sm text-gray-400 mb-1" data-id="element-162">
                    Área de Cobertura
                  </p>
                  <p className="text-white font-medium" data-id="element-163">
                    Central Florida (Orlando, Kissimmee, Davenport, Winter
                    Garden, Clermont y más)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-navy-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-164">
          <p className="text-gray-500 text-sm text-center md:text-left" data-id="element-165">
            &copy; {new Date().getFullYear()} Innova Pools & Systems. Todos los
            derechos reservados.
          </p>
          <div className="flex gap-6 text-sm" data-id="element-166">
            <a href="#" className="text-gray-500 hover:text-white transition-colors" data-id="element-167">
              Política de Privacidad
            </a>
            <a href="#" className="text-gray-500 hover:text-white transition-colors" data-id="element-168">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>;
}